<ng-container *ngIf="isAuthenticated$ | async as logado; else loading">
  <div *ngIf="logado" class="flex flex-col min-h-screen">
    <app-header *ngIf="this.generalService.showHeader"></app-header>

    <main class="flex-grow">
      <div id="content" class="container mx-auto px-base pt-base">       
        <app-notification
          [notifications]="this.generalService.notifications"
          *ngIf="this.generalService.notifications">
        </app-notification>
        <router-outlet></router-outlet>
      </div>
    </main>
    <app-page-footer></app-page-footer>
  </div>
</ng-container>

<ng-template #loading>
  <div class="flex flex-col items-center justify-center min-h-screen">
    <desy-spinner
      text="Cargando..."
      classes="text-6xl"
      ariaLabel="Cargando datos">
    </desy-spinner>
    <p class="mt-8 text-lg text-gray-600 text-center">
      Cargando...
    </p>
  </div>
</ng-template>
